
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import { UserModule } from '../../store/modules/user'
import loges from '../../components/course/loges.vue'
import AddListPop from '../../components/course/add-list-pop.vue'
import cropper from '../../components/course/cropper.vue'

  @Component({
    components: { loges, AddListPop, cropper}
  })
export default class AddList extends Vue {
    @Prop() dialogAdd: boolean
    @Prop() modifyHeader: any
    @Prop() optionList: any
    @Prop() optionId: string
    @Prop() isAddType: string
    @Prop() itemValue: any
    @Prop() pageName: string
    @Prop() allData: any
    pop_title: string = ''
    addOccupy: any = {}
    instrument_type_id: string = '' // 主题类型管理根据乐器类型id获取相应的要点
    w_default: any = '50%'
    searchList: any = [] // 搜索 string
    selectList: any = [] // 筛选 dict
    keyList: any = [] // 筛选 key_value / foreign-key
    booleanList: any = [] // 筛选 boolean
    numberList: any = [] // 筛选 number
    timeList: any = [] // 筛选 time
    colorList: any = [] // 筛选 color
    addList: any = []
    org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
    isEduOrderPage:boolean = false
    fileList: any = []
    upUrl: string = process.env.VUE_APP_IMG_API + 'api/core/upload-files/soco'
    editorOption: any = {
      modules: {
        toolbar: {
          container: [
            ['bold', 'italic', 'underline', 'strike'],        // 加粗，斜体，下划线，删除线
            ['blockquote', 'code-block'], // 引用，代码块
            [{ 'header': 1 }, { 'header': 2 }],               // 标题，键值对的形式；1、2表示字体大小
            [{ 'list': 'ordered' }, { 'list': 'bullet' }], // 列表
            [{ 'script': 'sub' }, { 'script': 'super' }],      // 上下标
            [{ 'indent': '-1' }, { 'indent': '+1' }],          // 缩进
            [{ 'direction': 'rtl' }],                         // 文本方向
            [{ 'size': ['small', false, 'large', 'huge'] }],  // 字体大小
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }], // 几级标题
            [{ 'color': [] }, { 'background': [] }],          // 字体颜色，字体背景颜色
            [{ 'font': [] }], // 字体
            [{ 'align': [] }],        // 对齐方式
            ['clean'],        // 清除字体样式
            ['link','image']        // 上传图片、上传视频
          ],
          handlers: {
            'image': function (value) {
                if (value) {
                    const dom: any = document.querySelector('.avatar-uploader input')
                    dom.click()
                } else {
                    this.quill.format('image', false);
                }
            }
          }
        }
      },
      theme: 'snow'
    }
    addCustomer_name: string = ''
    addCustomer_phone: string = ''
    essential: any = []
    props: any = { multiple: true }
    essentialOptions: any =  []
    logesFrom: string = ''
    actionBoolean: boolean = false
    orderId: string = ''
    is_show_log: boolean = false
    is_show_80: boolean = false

    // 商机管理 新建客户
    dialogAddPop: boolean = false
    modifyHeaderPop: any = []
    optionIdPop: string = ''
    optionListPop: any = []
    isAddTypePop: string = 'add'
    itemValuePop: any = []
    pageNamePop: string = ''
    allDataPop: any = {}
    logHeight: number = 800
    searchConditionInput: any = []
    is_customer_w_80: boolean = false
    is_customer_phone_add: boolean = false  // 判断新建客户弹窗走编辑接口还是新增接口
    is_customer_item: any = {}
    p_hight: any = window.innerHeight - 80 + 'px'
    quillUpdateImg: boolean = false // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
    serverUrl: string = process.env.VUE_APP_IMG_API + '/api/core/upload-files/soco'  // 这里写你要上传的图片服务器地址
    detailContent: string = '' // 富文本内容


    cropperModel: boolean = false
    file: string = ''
    isNewPic: boolean = false
    selectAll: boolean = false

    aaa: any = []
    checkList: any = []

    onEditorBlur() {} // 失去焦点事件
    onEditorFocus() {} // 获得焦点事件
    onEditorChange() {} // 内容改变事件

    // 上传图片前
    beforeUpload(res, file) {
      // 显示loading动画
      this.quillUpdateImg = true
    }
    // 上传图片成功
    uploadSuccess(res, file) {

      // res为图片服务器返回的数据
      // 获取富文本组件实例
      const imageUrl = 'https://'+ res[0]
      let quill = this.$refs.text[0].quill
      // 获取光标所在位置
      let length = quill.getSelection().index;
      // 插入图片  res.info为服务器返回的图片地址
      quill.insertEmbed(length, 'image', imageUrl)
      // 调整光标到最后
      quill.setSelection(length + 1)
      // loading动画消失
      this.quillUpdateImg = false
    }
    // 上传图片失败
    uploadError(res, file) {
      // loading动画消失
      this.quillUpdateImg = false
      this.$message.error('图片插入失败')
    }

    async getCustomerPhoneInfo(val) {
      const res: any = await CourseModule.getCustomerPhoneInfo({phone: val})
      if(res.code === 200) {
        if(res.data[0].is_add != 1) {   // 适配新建客户联系方式筛选 注： 有数据为编辑 无数据是新建
          this.is_customer_phone_add = false
          this.is_customer_item = res.data[0]
          this.assignment(this.addList, this.is_customer_item)
        } else {
          this.assignment(this.addList, res.data[0])
          this.is_customer_phone_add = true
        }
      }
    }
    changeCustomerPhone(val) {
      if(val.length === 11) {
        this.getCustomerPhoneInfo(val)
      }
    }

    arrCompare(arr, str) {
      let flag = arr.find((value, index, arr) => {
        return value === str
      })
      return flag
    }

    // deleteEssential(val) {
    //   let option:any = []
    //   let arr = []
    //   for (var i = 0; i < this.addList.length; i++) {
    //     if (this.addList[i].key === 'essential') {
    //       for (var j = 0; j < this.addList[i].model.length; j++) {
    //         if (this.addList[i].model[j].length === 1) {
    //           if (this.addList[i].model[j][0] === val.id) {
    //             this.addList[i].model.splice(j, 1)
    //           }
    //         } else if (this.addList[i].model[j].length === 2) {
    //           if (this.addList[i].model[j][1] === val.id) {
    //             this.addList[i].model.splice(j, 1)
    //           }
    //         }
    //       }
    //       this.manyChangeSelect(this.addList[i])
    //     }
    //   }
    // }

    manyChangeSelect(val) {
      if(this.pageName === 'edu-packet-page') {
        if(val.key === 'package_subject') {
          let num = 0
          let obj = {}
          for(var i = 0; i < this.addList.length; i++) {
            if(this.addList[i].key === 'package_subject') {
              if(this.addList[i].model && this.addList[i].model.length > 0) {
                for(var j = 0; j < this.addList[i].model.length; j++) {
                  for(var k = 0; k < this.addList[i].option.length; k++) {
                    if(this.addList[i].model[j] === this.addList[i].option[k].key) {
                      num += this.addList[i].option[k].estimate_class_hours
                    }
                  }
                }
              }
            }
            if(this.addList[i].key === 'estimate_class_hours') {
                obj = this.addList[i]
            }
          }
          obj['model'] = num
        }
      } else if (this.pageName === 'edu-subject-page' &&  val.key === 'essential') {
        let num = 0
        let obj = {}
        for(var i = 0; i < val.model.length; i++) {
          for(var j = 0; j < this.essentialOptions.length; j++) {
            if(this.essentialOptions[j].value === val.model[i][0]) {
              num += this.essentialOptions[j].class_hours
            }
            if(this.essentialOptions[j].children) {
              for(var k = 0; k < this.essentialOptions[j].children.length; k++) {
                if(val.model[i][0] === this.essentialOptions[j].children[k].value) {
                  num += this.essentialOptions[j].class_hours
                }
              }
            }
          }
        }
        for(var i = 0; i < this.addList.length; i++) {
          if(this.addList[i].key === 'estimate_class_hours') {
              obj = this.addList[i]
          }
        }
        obj['model'] = num
        const aaaList = []
        const modelList = []

        if (val.model.length === 0) {
          this.aaa = []
          this.checkList = []
          return false
        }

        for (var i = 0; i < this.aaa.length; i++) {
          if (this.aaa[i].length === 1) {
            aaaList.push(this.aaa[i][0])
          } else if (this.aaa[i].length === 2) {
            aaaList.push(this.aaa[i][1])
          }
        }

        for (var i = 0; i < val.model.length; i++) {
          if (val.model[i].length === 1) {
            modelList.push(val.model[i][0])
          } else if (val.model[i].length === 2) {
            modelList.push(val.model[i][1])
          }
        }

        // 对要点列表进行微操
        if (modelList.length > aaaList.length) {
          for (var i = 0; i < modelList.length; i++) {
            if(aaaList.indexOf(modelList[i]) < 0) {
              this.aaa.push(val.model[i])
            }
          }
        } else if (modelList.length < aaaList.length) {
          for (var i = 0; i < aaaList.length; i++) {
            if(modelList.indexOf(aaaList[i]) < 0) {
              this.aaa.splice(i, 1)
              aaaList.splice(i, 1)
            }
          }
        }

        this.checkList = []
        for (var j = 0; j < this.aaa.length; j++) {
          for(var k = 0; k < val.option.length; k++) {
            if (this.aaa[j].length === 1) {
              if (this.aaa[j][0] === val.option[k].key) {
                this.checkList.push({
                  id: this.aaa[j][0],
                  value: val.option[k].value
                })
              }
            } else if (this.aaa[j].length === 2) {
              if (this.aaa[j][1] === val.option[k].key) {
                this.checkList.push({
                  id: this.aaa[j][1],
                  value: val.option[k].value
                })
              }
            }
          }
        }

      } else if (this.pageName === 'edu-material-page' && val.key === 'teacher') {
        for(var i = 0; i < this.addList.length; i++) {
          if(this.addList[i].key === 'teacher') {   // 课程设置 - 课程素材设置 - 所属老师增加全选功能
            if(this.selectAll) {
              if (val.model.length === this.addList[i].option.length - 1 && val.model.includes("111")) {
                // 删除完全部按钮
                val.model.shift()
                this.addList[i].model = val.model
                this.selectAll = false
              }
              if (!val.model.includes("111") && this.addList[i].option.length - 1 === val.model.length) {
                // 点击取消全选
                this.addList[i].model = []
                this.selectAll = false
              }
            }else {
              if (val.model.includes("111")) {
                // 点击全选
                let arr = []
                for(var k = 0; k < this.addList[i].option.length; k++) {
                  arr.push(this.addList[i].option[k].key)
                }
                this.addList[i].model = arr
                this.selectAll = true
              }
              if (!val.model.includes("111") && this.addList[i].option.length - 1 === val.model.length) {
                // 选择完了所有按钮
                val.model.unshift('111')
                this.addList[i].model = val.model
                this.selectAll = true
              }
            }
          }
        }
      }
    }

    changeSelect(val) {
      if (this.pageName === 'edu-order-page') {
        if (val.key === 'business_id') {
          this.isEduOrderPage = true
          this.getOtherData(val.model, '')
          // this.getPacketData(val.model)
        } else if (val.key === 'customer_id') {
          this.isEduOrderPage = true
          this.getOtherData('', val.model)
        } else if (val.key === 'packet_id') {
          this.getPacket(val.model)
        } else if (val.key === 'campus_id') {
          this.getSaleGoodsList(val.model)
        } else if (val.key === 'other_name') {
          for (var j = 0; j < val.option.length; j++) {
            if (val.option[j].key === val.model) {
              const price = val.option[j].price
              for (var k = 0; k < this.addList.length; k++) {
                if(this.addList[k].key === 'goods_number') {
                  const number = this.addList[k].model
                  for (var m = 0; m < this.addList.length; m++) {
                    if (this.addList[m].key === 'price') {
                      this.addList[m].model = Number(price) * Number(number)
                    }
                  }
                }
              }
            }
          }
        }
      } else if (this.pageName === 'edu-business-page') {
        if (val.key === 'customer_id') {
          this.isEduOrderPage = true
          this.getCustomerInfo(val.model)
        }
      } else if (this.pageName === 'edu-subject-page' && val.key === 'instrument_type_id') {
          this.instrument_type_id = val.model
          this.essentialList()
      }
    }

    async essentialList() {
      let data = {
        is_enabled: 1,
        instrument_type_id: this.instrument_type_id
      }
      const res: any = await CourseModule.essentialList(data)
      if (res.code === 200) {
        this.essential = res.data.list
        let data = []
        if(this.essential.length > 0) {
          for(var i = 0; i < this.essential.length;i++) {
            let obj = {
              value: '',
              label: '',
              class_hours: 0,
              children: []
            }
            obj['value'] = this.essential[i].id
            obj['label'] = this.essential[i].name
            obj['class_hours'] = this.essential[i].class_hours
            if(this.essential[i].two_data.length > 0) {
              for(var j = 0; j <  this.essential[i].two_data.length; j++) {
                let obj1 = {}
                obj1['value'] = this.essential[i].two_data[j].id
                obj1['label'] = this.essential[i].two_data[j].name
                obj1['class_hours'] = this.essential[i].two_data[j].class_hours
                obj.children.push(obj1)
              }
            } else {
              delete obj['children']
            }
            data.push(obj)
          }
        }
        this.essentialOptions = data

        //  根据乐器类型变化引动预估课时变化
        let obj = {}
        let num = 0
        for(var m = 0; m < this.addList.length; m++) {
          if(this.addList[m].key === 'essential') {
            let val = this.addList[m]
            for(var i = 0; i < val.model.length; i++) {
              for(var j = 0; j < this.essentialOptions.length; j++) {
                if(this.essentialOptions[j].value === val.model[i][0]) {
                  num += this.essentialOptions[j].class_hours
                }
                if(this.essentialOptions[j].children) {
                  for(var k = 0; k < this.essentialOptions[j].children.length; k++) {
                    if(val.model[i][0] === this.essentialOptions[j].children[k].value) {
                      num += this.essentialOptions[j].class_hours
                    }
                  }
                }
              }
            }
          }
        }
        for(var i = 0; i < this.addList.length; i++) {
          if(this.addList[i].key === 'estimate_class_hours') {
              obj = this.addList[i]
          }
        }
         obj['model'] = num
      }
    }

    async getCustomerInfo(val) {
      const res: any = await CourseModule.customeInfo({ customer_id: val })
      this.assignment(this.addList, res.data[0])
      this.addCustomer_name = res.data[0].name
      this.addCustomer_phone = res.data[0].phone
    }

    changeDict(val) {
      if (this.pageName === 'edu-order-page') {
        if (val.key === 'order_type') {
          if (val.model === 1) { // 课程类
            this.orderChange(1)
          } else if (val.model === 2) { // 物品类
            this.orderChange(2)
          }
        }
      } else if (this.pageName === 'edu-business-page' && val.key === 'business_type') {
        if (Number(val.model) === 2) {  // 非试听
          this.getChange(false, 'teacher_id')
        } else if(Number(val.model) === 1) {  // 试听
          this.getChange(true, 'teacher_id')
        }
      }
    }

    async getPacket(id) {
      const res: any = await CourseModule.getPacket({ packet_id: id })
      for (var i = 0; i < this.addList.length; i++) {
        if (this.addList[i].key === 'price') {
          this.addList[i].model = res.data[0].price
        }
      }
    }

    async getSaleGoodsList(id) {
      const res: any = await CourseModule.saleGoodsList({ campus_id: id })
      for (var i = 0; i < this.addList.length; i++) {
        if (this.addList[i].key === 'other_name') {
          this.addList[i].option = res.data
        }
      }
    }

    orderChange(type) {
      for (var i = 0; i < this.addList.length; i++) {
        if (type === 1) {  // 课程类 展示“当前套餐”框，不能展示“物品名称”“购买数量”字样；
          if (this.addList[i].key === 'packet_id') {
            this.addList[i].show = true
          } else if (this.addList[i].key === 'other_name') {
            this.addList[i].show = false
            this.addList[i].model = ''
          } else if (this.addList[i].key === 'goods_number'){
            this.addList[i].show = false
            this.addList[i].model = ''
          } else if (this.addList[i].key === 'price') {
            this.addList[i].model = 0
          } else if (this.addList[i].key === 'audition_teacher_employee_id' || this.addList[i].key === 'teacher_employee_id') {
            this.addList[i].model = ''
            this.addList[i].show = true
          }
        } else if (type === 2) {
          if (this.addList[i].key === 'packet_id') {
            this.addList[i].show = false
            this.addList[i].model = ''
          } else if (this.addList[i].key === 'other_name') {
            this.addList[i].show = true
          } else if (this.addList[i].key === 'goods_number') {
            this.addList[i].show = true
            this.addList[i].model = 1
          } else if (this.addList[i].key === 'price') {
            this.addList[i].model = ''
          } else if (this.addList[i].key === 'audition_teacher_employee_id' || this.addList[i].key === 'teacher_employee_id') {
            this.addList[i].model = ''
            this.addList[i].show = false
          }
        }
      }
    }

    async getOtherData(id, customer_id) {
      const res: any = await CourseModule.getBusiness({ business_id: id, customer_id: customer_id })
      if (res.code === 200) {
          if (customer_id) {
            let businessList = []
            if(res.data && res.data.length > 0) {
              for (var i = 0; i < res.data.length; i++) {
                businessList.push({ key: res.data[i].id, value: res.data[i].business_name, campus_id: res.data[i].campus_id })
                if (i == 0) {
                  //  获取套餐
                  this.getPacketData(res.data[0].campus_id)
                }
              }
              for (var i = 0; i < this.addList.length; i++) {
                if (this.addList[i].key === 'business_id') {
                  this.addList[i].option = businessList
                  this.addList[i].model = businessList[0].key
                }
                if (this.addList[i].key === 'campus_id') {
                  this.addList[i].model = businessList[0].campus_id
                }
              }
            } else {
              for (var i = 0; i < this.addList.length; i++) {
                if (this.addList[i].key === 'packet_id') {
                  this.addList[i].option = []
                }
                if (this.addList[i].key === 'business_id') {
                  this.addList[i].option = []
                  this.addList[i].model = ''
                }
                if (this.addList[i].key === 'campus_id') {
                  this.addList[i].model = ''
                }
              }
            }
            this.assignment(this.addList, res.data[0])
          } else {
            //  获取套餐
            let pack_campus_id = ''
            if (res.data.length > 0) {
              pack_campus_id = res.data[0].campus_id
            }
            this.getPacketData(pack_campus_id)
            this.assignment(this.addList, res.data[0])
          }
      }
    }

    async getPacketData(id) {
      const res: any = await CourseModule.getPacketData({ campus_id: id })
      for (var i = 0; i < this.addList.length; i++) {
        if (this.addList[i].key === 'packet_id') {
          this.addList[i].option = res.data
        }
      }
    }
    numberChange(val) {
      for (var i = 0; i < this.addList.length; i++) {
        if (this.addList[i].key === 'other_name') {
          for(var j = 0; j < this.addList[i].option.length; j++) {
            if (this.addList[i].option[j].key === this.addList[i].model) {
              const price = this.addList[i].option[j].price
              for (var k = 0; k < this.addList.length; k++) {
                if(this.addList[k].key === 'price') {
                  this.addList[k].model = val.model * Number(price)
                }
              }
            }
          }
        }
      }
    }
    newOrder(){
      if(this.pageName === 'edu-order-page') {
        let customer_id = this.$route.query.customer_id
        let business_id = this.$route.query.business_id
        if(this.itemValue['customer_id']) {
          customer_id = this.itemValue['customer_id']
        }
        this.isEduOrderPage = true
        this.getOtherData('', customer_id)
        this.getOtherData(business_id, '')
        this.getPacketData(business_id)
      }

    }
    closeLoges(){
      this.is_show_log = false
      this.actionBoolean = false
      this.w_default = '50%'
    }
    addSuccessPop(val) {
      if(val.type === 'true') {
        for(var j=0;j<this.addList.length;j++) {
          if(this.addList[j].key === 'customer_id') {
            this.addList[j].option.push({key: val.customer_id, value: val.customer_name})
            this.addList[j].model = val.customer_id
            this.isEduOrderPage = true
            this.getCustomerInfo(val.customer_id)
          }
        }
      }
      this.dialogAddPop = false
    }


     // 创建客户
    createCustomer() {
      this.getCustomrListPop()
    }
    async optionPop() {
      const res: any = await CourseModule.options({ optionId: this.optionIdPop, org_id: this.org_id })
      if (res.code === 200) {
        this.optionListPop = res.data
        this.dialogAddPop = true
      }
    }
    async getCustomrListPop() {
      const res: any = await CourseModule.customerPage({ org_id: this.org_id })
      if (res.code === 200) {
        let header = res.data.page_section[0].entity.entity_fields
        this.modifyHeaderPop = []
        for (var i = 0; i < header.length; i++) {
          const existsType: string = header[i].exists_type
          if (existsType.indexOf('modify') >= 0) {
            this.modifyHeaderPop.push(header[i])
          }
        }
        this.optionIdPop = res.data.page_section[0].entity.id
        this.pageNamePop = res.data.key
        this.allDataPop = res.data
        this.optionPop()
      }
    }

    getHeight() {
      window.onresize = () => {
        this.p_hight = window.innerHeight - 80 + 'px'
      }
    }
    @Watch('dialogAdd', { immediate: true })
    isShow(val) {
      this.aaa = []
      this.checkList = []
      this.getHeight()
      this.newOrder()
      if(this.isAddType === 'add') {
        this.pop_title = '添加'
        this.selectAll = false
        this.checkList = []
      } else {
        this.pop_title = '编辑'
      }
      if (this.pageName === 'edu-article-page' || this.pageName === 'edu-agreement-page' || this.pageName === 'edu-about-page' || this.pageName === 'edu-employee-page') {
        this.w_default = '80%'
      }
      if (val) {
        if(this.pageName === 'edu-customer-page') {
          if(this.isAddType === 'edit') {
            this.is_customer_phone_add = false
            this.actionBoolean = true
            this.orderId = this.itemValue.id
            this.logesFrom = 'edu_customer'
            this.w_default = '80%'
            this.is_show_log = true
            this.is_customer_w_80 = false
          } else {
            this.is_customer_phone_add = true
            this.is_customer_w_80 = true
            this.actionBoolean = false
            this.is_show_log = false
          }
        } else if (this.pageName === 'edu-business-page') {
          if(this.isAddType === 'edit') {
            this.actionBoolean = true
            this.orderId = this.itemValue.id
            this.logesFrom = 'edu_business'
            this.w_default = '80%'
            this.is_show_log = true
          } else {
            this.actionBoolean = false
            this.w_default = '50%'
            this.is_show_log = false
          }
        }

        this.addList = []
        console.log(this.modifyHeader, 'headerrrrrr')
        for (var i = 0; i < this.modifyHeader.length; i++) {
          const table_name = this.modifyHeader[i].table_name ? this.modifyHeader[i].table_name : ''
          if (this.modifyHeader[i].data_type === 'string') {
            if (this.modifyHeader[i].key === 'other_name') {
              this.addList.push({ show: false, name: this.modifyHeader[i].name, model: '', key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
            } else if (this.modifyHeader[i].key === 'estimate_class_hours') {
              this.addList.push({ show: true, name: this.modifyHeader[i].name, model: 0, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
            } else {
              this.addList.push({ show: true, name: this.modifyHeader[i].name, model: '', key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
            }
          } else if (this.modifyHeader[i].data_type === 'dict') {
            if (this.modifyHeader[i].key === 'order_type' && this.pageName === 'edu-order-page') {
              this.addList.push({ show: true, name: this.modifyHeader[i].name, model: 1, option: this.modifyHeader[i].dict_list, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
            } else if (this.pageName === 'edu-base-course-page' && this.modifyHeader[i].key === 'class_minutes') {
              this.addList.push({ show: true, name: this.modifyHeader[i].name, model: 60, option: this.modifyHeader[i].dict_list, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
            } else if (this.pageName === 'edu-business-page' && this.modifyHeader[i].key === 'business_status') {
              this.addList.push({ show: true, name: this.modifyHeader[i].name, model: '2', option: this.modifyHeader[i].dict_list, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
            } else if (this.pageName === 'edu-customer-page'){
              if(this.modifyHeader[i].key === 'status') {
                for(var j = 0;j < this.modifyHeader[i].dict_list.length; j++) {
                  this.modifyHeader[i].dict_list[j].key = Number(this.modifyHeader[i].dict_list[j].key)
                }
                this.addList.push({ show: true, name: this.modifyHeader[i].name, model: 1, option: this.modifyHeader[i].dict_list, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
              } else if (this.modifyHeader[i].key === 'intention') {
                this.addList.push({ show: true, name: this.modifyHeader[i].name, model: 2, option: this.modifyHeader[i].dict_list, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
              } else {
                this.addList.push({ show: true, name: this.modifyHeader[i].name, model: '', option: this.modifyHeader[i].dict_list, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
              }
            } else {
              this.addList.push({ show: true, name: this.modifyHeader[i].name, model: '', option: this.modifyHeader[i].dict_list, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
            }
          } else if (this.modifyHeader[i].data_type === 'key_value' || this.modifyHeader[i].data_type === 'foreign-key') {
            if (this.modifyHeader[i].foreign_type === 'many-to-many') {
              if(this.pageName === 'edu-material-page' && this.modifyHeader[i].key === 'teacher') {
                let option = this.optionList[this.modifyHeader[i].key]
                let flag = option.find((value, index, arr) => {
                  return value.key === '111'
                })
                if(!flag) {
                  option.unshift({'key': '111', value: '全部'})
                }
                this.addList.push({ show: true, name: this.modifyHeader[i].name, model: [], type: 'array', option: option, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type, foreign_type: this.modifyHeader[i].foreign_type })
              } else {
                let option = []
                for (var m = 0; m < this.optionList[this.modifyHeader[i].key].length; m++) {
                  const it = this.optionList[this.modifyHeader[i].key][m]
                  if (it.is_enabled === 1) {
                    option.push(it)
                  } else {
                    if (it.is_enabled === 0) {
                    } else {
                      option.push(it)
                    }
                  }
                }
                this.addList.push({ show: true, name: this.modifyHeader[i].name, model: [], type: 'array', option: option, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type, foreign_type: this.modifyHeader[i].foreign_type })
              }
            } else {
              let optionArr = []
              for (var k = 0; k < this.optionList[this.modifyHeader[i].key].length; k++) {
                if (this.optionList[this.modifyHeader[i].key][k].is_enabled === 1) {
                  optionArr.push(this.optionList[this.modifyHeader[i].key][k])
                } else if (this.optionList[this.modifyHeader[i].key][k].is_enabled === 0) {

                } else {
                  optionArr.push(this.optionList[this.modifyHeader[i].key][k])
                }
              }
              if(this.modifyHeader[i].key === 'employee_id') {
                this.addList.push({ show: false, name: this.modifyHeader[i].name, model: '', type: 'string', option: optionArr, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type, foreign_type: this.modifyHeader[i].foreign_type })
              } else {
                this.addList.push({ show: true, name: this.modifyHeader[i].name, model: '', type: 'string', option: optionArr, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type, foreign_type: this.modifyHeader[i].foreign_type })
              }
            }
          } else if (this.modifyHeader[i].data_type === 'boolean') {
            if ((this.modifyHeader[i].key === 'is_other' && this.pageName === 'edu-packet-page') || 
              (this.modifyHeader[i].key === 'is_hour_limit' && this.pageName === 'edu-packet-page')) {
              this.addList.push({ show: true, name: this.modifyHeader[i].name, model: 1, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
            } else if ((this.modifyHeader[i].key === 'is_formal' && this.pageName === 'edu-base-course-page') || (this.modifyHeader[i].key === 'is_cancel' && this.pageName === 'edu-base-course-page') || (this.modifyHeader[i].key === 'is_enabled' && this.pageName === 'edu-material-page')) {
              this.addList.push({ show: true, name: this.modifyHeader[i].name, model: 1, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
            } else {
              this.addList.push({ show: true, name: this.modifyHeader[i].name, model: '', key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
            }
          } else if (this.modifyHeader[i].data_type === 'number') {
            this.addList.push({ show: true, name: this.modifyHeader[i].name, model: undefined, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
          } else if (this.modifyHeader[i].data_type === 'datetime') {
            this.addList.push({ show: true, name: this.modifyHeader[i].name, model: '', key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
          } else if (this.modifyHeader[i].data_type === 'global-component') {
            this.addList.push({ show: true, name: this.modifyHeader[i].name, model: '', key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
          } else if (this.modifyHeader[i].data_type === 'rich_text') {
            this.addList.push({ show: true, name: this.modifyHeader[i].name, model: `<p></p>`, key: this.modifyHeader[i].key, table_name: table_name, data_type: this.modifyHeader[i].data_type })
          }
        }
        if(this.isAddType === 'add') {
          if(this.pageName === 'edu-business-page') {
            this.is_show_80 = true
          } else if (this.pageName === 'edu-order-page') {
            for(var i =0;i<this.addList.length;i++) {
              if(this.addList[i].key === 'other_name' || this.addList[i].key === 'goods_number') {
                this.addList[i].show = false
              }
            }
          } else if (this.pageName === 'edu-banner-page' || this.pageName === 'edu-article-page') {
            this.getChange(this.itemValue.is_campus, 'campus')
          }
        }

        if (this.isAddType === 'edit') {
          this.is_show_80 = false
          // this.getChange(this.itemValue.is_hour_limit, 'class_hours')
          this.assignment(this.addList, this.itemValue)
          this.removeRepeat(this.addList, this.itemValue)
          const imgList = this.addList.map((item) => {
            if (this.pageName === 'edu-banner-page') {
              if (item.key === 'image_url') {
                this.fileList = [{
                  url: item.model
                }]
                return 1
              }
            } else {
              return 0
            }
          })
          if(this.pageName === 'edu-subject-page') {
            this.instrument_type_id = this.itemValue.instrument_type_id.key
            this.essentialList()
          } else if (this.pageName === 'edu-banner-page' || this.pageName === 'edu-article-page') {
            this.getChange(this.itemValue.is_campus, 'campus')
          } else if (this.pageName === 'edu-business-page') {
            if (Number(this.itemValue.business_type) === 2) {  // 非试听
              this.getChange(false, 'teacher_id')
            } else if(Number(this.itemValue.business_type) === 1) {  // 试听
              this.getChange(true, 'teacher_id')
            }
          }
        }
        if (this.pageName === 'edu-employee-page') {
          for (var i = 0; i < this.addList.length; i++) {
            if (this.addList[i].key === 'is_teacher') {
              this.changeTeacher(this.addList[i].model)
            }
          }
        }
      }
    }

    assignment(one, two) {
      for (var i = 0; i < one.length; i++) {
        for (var j in two) {
          if (one[i].key === j) {
            if (one[i].data_type === 'dict') {
              let flag = false
              for (var k = 0; k < one[i].option.length; k++) {
                if(Number(one[i].option[k].key) === Number(two[j])) {
                  flag = true
                }
                one[i].option[k].key = Number(one[i].option[k].key)
              }
              if(flag) {
                one[i].model = Number(two[j])
              } else {
                one[i].model = ''
              }

            } else if (one[i].data_type === 'datetime') {
              one[i].model = new Date(two[j] * 1000)
            } else if (one[i].data_type === 'key_value' || one[i].data_type === 'foreign-key') {
              if (one[i].type === 'string') {
                if (this.isEduOrderPage) {
                  one[i].model = two[j]
                } else {
                  one[i].model = two[j].key
                }
              } else if (one[i].type === 'array') {
                if(this.pageName === 'edu-subject-page' && one[i].key === 'essential') {
                  const essential_content = JSON.parse(two['essential_content'])
                  one[i].model = essential_content
                  // this.aaa = essential_content
                  const essential = two['essential']

                  this.aaa = []
                  for (var m = 0; m < essential.length; m++) {
                    for (var n = 0; n < essential_content.length; n++) {
                      if(essential_content[n].length === 1) {
                        if (essential[m] === essential_content[n][0]) {
                          this.aaa.push(essential_content[n])
                        }
                      }else if (essential_content[n].length === 2) {
                        if (essential[m] === essential_content[n][1]) {
                          this.aaa.push(essential_content[n])
                        }
                      }
                    }
                  }

                  for (var n = 0; n < this.addList.length; n++) {
                    if (this.addList[n].key === 'essential') {
                      for (var m = 0; m < essential.length; m++) {
                        for(var k = 0; k < this.addList[n].option.length; k++) {
                          if (essential[m] === this.addList[n].option[k].key) {
                            this.checkList.push({
                              id: essential[m],
                              value: this.addList[n].option[k].value
                            })
                          }
                        }
                      }
                    }
                  }

                } else if (this.pageName === 'edu-material-page' && one[i].key === 'teacher') {
                  if(two[j].length === one[i].option.length - 1) {
                    two[j].unshift('111')
                    this.selectAll = true
                  } else {
                    this.selectAll = false
                  }
                   one[i].model = two[j]

                } else {
                  one[i].model = two[j]
                }
              }
            } else {
              one[i].model = two[j]
            }
          }
        }
      }
    }
    removeRepeat(one, two) {
      let arr = []
      for (var i = 0; i < one.length; i++) {
        for (var j in two) {
          if (one[i].key === j) {
            if (one[i].data_type === 'key_value' || one[i].data_type === 'foreign-key') {
              if (this.pageName === 'edu-material-page' && one[i].key === 'teacher') {
                // 筛选项集合
                let optionArr = []
                for (var m = 0; m < one[i].option.length; m++) {
                  optionArr.push(one[i].option[m].key)
                }
                if(one[i].model[0] === '111') {
                  one[i].model = optionArr
                } else {
                  for (var k = 0; k < one[i].model.length; k++) {
                    if (optionArr.indexOf(one[i].model[k]) >= 0) {
                      arr.push(one[i].model[k])
                    }
                  }
                  one[i].model = arr
                }
              }
            }
          }
        }
      }
    }

    close() {
      this.$emit('add-type', false)
      this.closeLoges()
      this.isEduOrderPage = false
      this.fileList = []  // 编辑banner在新建会出现文件列表故特殊处理
    }
    add() {
      let data = {
        data: {}
      }
      for (var i = 0; i < this.addList.length; i++) {
        if (this.addList[i].data_type === 'datetime') {
          data.data[this.addList[i].key] = Date.parse(this.addList[i].model) / 1000
        } else if(this.addList[i].key === 'teacher') {
          if(this.addList[i].model.includes('111')) {
            this.addList[i].model.shift()
          }
          data.data[this.addList[i].key] = this.addList[i].model
        } else {
          data.data[this.addList[i].key] = this.addList[i].model
        }
      }

      if(this.pageName === 'edu-customer-page' && this.isAddType === 'add') {
        if(this.is_customer_phone_add) {
          if (this.allData.page_section[0].entity.has_connect_org) {
            data.data['org_id'] = this.org_id
          }
          this.addData(data)
        } else {
          data['data_id'] = this.is_customer_item.id
          this.editData(data)
        }
      } else {
        if (this.isAddType === 'add') {
          if (this.allData.page_section[0].entity.has_connect_org) {
            data.data['org_id'] = this.org_id
          }
          this.addData(data)
        } else if (this.isAddType === 'edit') {
          data['data_id'] = this.itemValue.id
          this.editData(data)
        }
      }
    }

    async editData(data) {
      if(this.pageName === 'edu-subject-page') {
        data.data['essential_content'] = JSON.stringify(data.data.essential)
        let newArr = []
        for(var i = 0; i < this.checkList.length; i++) {
          newArr.push(this.checkList[i].id)
        }
        data.data.essential = newArr
      }

      const res: any = await CourseModule.editItem({ data: data, optionId: this.optionId })
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: '编辑成功!'
        })
        this.isEduOrderPage = false
        this.$emit('add-type', true)
      } else {
        this.isEduOrderPage = false
        this.$message.error('编辑失败！')
      }
      this.closeLoges()
    }

    async addData(data) {
      if(this.pageName === 'edu-subject-page') {
        data.data['essential_content'] = JSON.stringify(data.data.essential)
        let newArr = []
        for(var i = 0; i < this.checkList.length; i++) {
          newArr.push(this.checkList[i].id)
        }
        data.data.essential = newArr
      }

      if (this.pageName === 'edu-order-page') {
        if(data.data.order_type === 2) {  // 物品类
          if (!data.data.other_name) {
            this.$message.warning('请选择物品名称！')
            return false
          }
        }
        if (data.data.order_type === 1) {  // 课程类
          if (!data.data.packet_id) {
            this.$message.warning('请选择课程套餐！')
            return false
          }
        }
        const res: any = await CourseModule.addItemOrder({ data: data })
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: '添加成功!'
          })
          this.$emit('add-type', true)
        } else {
          this.$message.error('添加失败！')
        }
      } else if (this.pageName === 'edu-customer-page') {
        const res: any = await CourseModule.addItemCustomer({ data: data })
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: '添加成功!'
          })
          this.$emit('add-type', {type: 'true', customer_id: res.data.customer_id})
        } else {
          this.$message.error('添加失败！')
        }
      } else {
        if (this.pageName === 'edu-business-page') {
          data.data.name = this.addCustomer_name
          data.data.phone = this.addCustomer_phone
        }
        const res: any = await CourseModule.addItem({ data: data, optionId: this.optionId })
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: '添加成功!'
          })
          if(this.pageName === 'edu-business-page') {
            if(res.data && res.data.customer_name) {
              this.$emit('add-type', {type: 'true', customer_name: res.data.customer_name})
            } else {
              this.$emit('add-type', {type: 'true'})
            }
          } else {
            this.$emit('add-type', {type: 'true'})
          }
        } else {
          this.$message.error('添加失败！')
        }
      }
    }
    getChange(val, type) {
      for (var i = 0; i < this.addList.length; i++) {
        if (this.addList[i].key === type) {
          if (val) {
            this.addList[i].show = true
          } else {
            this.addList[i].show = false
            this.addList[i].model = ''
          }
        }
      }
    }
    changeTeacher(val) {
      for (var i = 0; i < this.addList.length; i++) {
        if (this.addList[i].key === 'expect_release_hour' || this.addList[i].key === 'instrument_type_id' || this.addList[i].key === 'teacher_profile' || this.addList[i].key === 'teacher_level') {
          if (!val) {
            this.addList[i].show = false
          } else {
            this.addList[i].show = true
          }
        }
      }
    }

    // 监听是否限制课时控制总课时
    activeChange(val, item) {
      if (this.pageName === 'edu-packet-page' && item.key === 'is_hour_limit') {
        this.getChange(val, 'class_hours')
      } else if (this.pageName === 'edu-employee-page' && item.key === 'is_teacher') {
        this.changeTeacher(val)
      } else if ((this.pageName === 'edu-banner-page' || this.pageName === 'edu-article-page')  && item.key === 'is_campus') {
        this.getChange(val, 'campus')
      } else if (this.pageName === 'edu-base-course-page' && item.key === 'is_cancel'){
        this.getChange(val, 'cancel_time')
      }
    }
    beforeClose(val) {
      this.cropperModel = false
    }
    async upload(val) {
      const data = {
        base_str: val
      }
      const res: any = await CourseModule.upPicture(data)
      if(res.code === 200) {
        this.addList.forEach(element => {
          if (element.key === 'image_url') {
            element.model = 'https://' + res.data
          }
        })
        this.cropperModel = false
      }
    }
    handleChange(file, fileList) {
      this.cropperModel = true
      this.file = file
    }
    handleRemove(file, fileList) {}
    handlePreview(file) {}
    onBeforeUp(file) {}
    onSuccessUp(res, file) {
      this.addList.forEach(element => {
        if (element.key === 'image_url') {
          element.model = 'https://' + res[0]
        }
      })
    }
    mounted() {}
}
